import { ref } from '@vue/composition-api';
import { useConfig } from './useConfig';
import { I18nPluralizationResolver, I18nResolver, Locale } from '../types';

// 默认语言为中文
const locale = ref<Locale>('zh');

export const useLocale = (i18nResolver?: I18nResolver, i18nPluralizationResolver?: I18nPluralizationResolver) => {
  const config = useConfig({ i18nResolver, i18nPluralizationResolver });
  return {
    locale,
    changeLocale(newLocale: Locale) {
      locale.value = newLocale;
    },
    t(key: string, ...args: any[]) {
      if (config.i18nResolver && typeof config.i18nResolver === 'function') {
        return Reflect.apply(config.i18nResolver, null, [key, ...args]);
      }
      return key;
    },
    tc(key: string, num: number, ...args: any[]) {
      if (config.i18nPluralizationResolver && typeof config.i18nPluralizationResolver === 'function') {
        return Reflect.apply(config.i18nPluralizationResolver, null, [key, num, ...args]);
      }
      return key;
    }
  };
};
